module.exports = __webpack_public_path__ + "static/media/icon_menu_btn.6334d12a.svg";